import React from 'react';

const ContainerLayoutTab = ({ block, updateStyle }) => {
  if (!block) return null;

  return (
    <div className="container-layout-tab" style={{ padding: '12px' }}>
      
      {/* Background Section (Common) */}
      <div className="property-group" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
        <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Background</h4>
        <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#374151' }}>Color</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input 
                    type="color" 
                    value={block.style?.backgroundColor || '#ffffff'} // Default fallback if undefined
                    onChange={(e) => updateStyle('backgroundColor', e.target.value)}
                    style={{ width: '36px', height: '36px', padding: 0, border: '1px solid #d1d5db', borderRadius: '4px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '12px', color: '#6b7280' }}>
                    {block.style?.backgroundColor || 'Transparent'}
                </span>
                 <button 
                    onClick={() => updateStyle('backgroundColor', 'transparent')}
                    style={{ 
                        marginLeft: 'auto', 
                        fontSize: '11px', 
                        padding: '4px 8px', 
                        backgroundColor: '#f3f4f6', 
                        border: '1px solid #d1d5db', 
                        borderRadius: '4px',
                        cursor: 'pointer' 
                    }}
                >
                    Clear
                </button>
            </div>
        </div>
      </div>

      {/* Spacing Section (Common) */}
      <div className="property-group" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
        <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Spacing</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#374151' }}>Padding</label>
                <input 
                    type="text" 
                    value={block.style?.padding || ''}
                    onChange={(e) => updateStyle('padding', e.target.value)}
                    placeholder="e.g. 20px"
                    style={{ width: '100%', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px' }}
                />
            </div>
            <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#374151' }}>Margin</label>
                <input 
                    type="text" 
                    value={block.style?.margin || ''}
                    onChange={(e) => updateStyle('margin', e.target.value)}
                    placeholder="e.g. 10px"
                    style={{ width: '100%', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px' }}
                />
            </div>
        </div>
      </div>

      {/* Section Specific */}
      {block.type === 'section' && (
        <div className="property-group" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
            <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#1e40af' }}>Dimensions</h4>
             <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#1e40af' }}>Min Height</label>
                <input 
                    type="text" 
                    value={block.style?.minHeight || ''}
                    onChange={(e) => updateStyle('minHeight', e.target.value)}
                    placeholder="e.g. 100px"
                     style={{ width: '100%', padding: '6px 8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px' }}
                />
            </div>
        </div>
      )}

      {/* Row Specific */}
      {block.type === 'row' && (
        <div className="property-group" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#ecfdf5', borderRadius: '8px', border: '1px solid #a7f3d0' }}>
            <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#047857' }}>Row Layout</h4>
             <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#047857' }}>Gap</label>
                <input 
                    type="text" 
                    value={block.style?.gap || ''}
                    onChange={(e) => updateStyle('gap', e.target.value)}
                    placeholder="e.g. 10px"
                     style={{ width: '100%', padding: '6px 8px', border: '1px solid #6ee7b7', borderRadius: '4px', fontSize: '13px' }}
                />
            </div>
        </div>
      )}

      {/* Column Specific */}
      {block.type === 'column' && (
        <div className="property-group" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#fffbeb', borderRadius: '8px', border: '1px solid #fde68a' }}>
             <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#b45309' }}>Column Dimensions & Border</h4>
             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#b45309' }}>Width</label>
                    <input 
                        type="text" 
                        value={block.style?.width || ''}
                        onChange={(e) => updateStyle('width', e.target.value)}
                        placeholder="e.g. 50% or auto"
                         style={{ width: '100%', padding: '6px 8px', border: '1px solid #fcd34d', borderRadius: '4px', fontSize: '13px' }}
                    />
                </div>
                 <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#b45309' }}>Flex Grow</label>
                    <input 
                        type="number" 
                        value={block.style?.flex ?? 1}
                        onChange={(e) => updateStyle('flex', parseFloat(e.target.value))}
                         style={{ width: '100%', padding: '6px 8px', border: '1px solid #fcd34d', borderRadius: '4px', fontSize: '13px' }}
                    />
                </div>
            </div>
            
            <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#b45309' }}>Border Width</label>
                <input 
                    type="text" 
                    value={block.style?.borderWidth || ''}
                    onChange={(e) => updateStyle('borderWidth', e.target.value)}
                    placeholder="e.g. 1px"
                     style={{ width: '100%', padding: '6px 8px', border: '1px solid #fcd34d', borderRadius: '4px', fontSize: '13px' }}
                />
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                 <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#b45309' }}>Border Color</label>
                    <input 
                        type="color" 
                        value={block.style?.borderColor || '#000000'}
                        onChange={(e) => updateStyle('borderColor', e.target.value)}
                        style={{ width: '100%', height: '32px', border: '1px solid #fcd34d', borderRadius: '4px' }}
                    />
                </div>
                 <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#b45309' }}>Border Style</label>
                    <select 
                        value={block.style?.borderStyle || 'solid'}
                        onChange={(e) => updateStyle('borderStyle', e.target.value)}
                         style={{ width: '100%', padding: '6px 8px', border: '1px solid #fcd34d', borderRadius: '4px', fontSize: '13px' }}
                    >
                        <option value="solid">Solid</option>
                        <option value="dashed">Dashed</option>
                        <option value="dotted">Dotted</option>
                        <option value="none">None</option>
                    </select>
                </div>
            </div>
        </div>
      )}

    </div>
  );
};

export default ContainerLayoutTab;
